import "react-toggle/style.css";
import axios from "axios";
import config from "../../app.json";
import React, { useState, useEffect } from "react";
import { Col, Button } from "react-bootstrap";
import FieldSelect from "../Fields/FieldSelect";
import AlertComponent from "../AlertComponent";
function AddOrEditElementalLinkInput(props) {
  const { inputName, handleAddNewElementsInput, deviceOptions, currentElement } = props;
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    if (!currentElement) {
      return;
    }
    setSelectedDevice(deviceOptions?.filter(x => x.value == currentElement.elementalLinkId)?.at(0));
  }, [currentElement, deviceOptions]);

  const onSubmitHandler = () => {
    if (!inputName || !inputName.length) {
      return AlertComponent("Error", "Input name is required.", {
        icon: `error`,
      });
    }

    if (!selectedDevice) {
      return AlertComponent("Error", "Device is required.", {
        icon: `error`,
      });
    }

    let item = {
      name: inputName,
      elementalLinkId: selectedDevice?.value,
    };

    if (currentElement) {
      item.id = currentElement.id;
    }

    axios
      .post(config.API + "/api/Input/saveInputElementalLink", item)
      .then((res) => {
        if (res.status === 200 && res.data) {
          const newInput = { ...res.data };
          delete newInput.$id;
          handleAddNewElementsInput(newInput);
          return AlertComponent(
            "Success",
            "Input has been saved successfully"
          );
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  return (
    <Col className="new-channel-inputsx">
      <div>
        <FieldSelect
          label={`Select the device`}
          options={deviceOptions}
          className={`col-md-12`}
          id={`selectedDevice`}
          name={`selectedDevice`}
          onChange={setSelectedDevice}
          value={selectedDevice}
          placeholder={`Choose the device`}
        />

        <Button className="dark-btn mt-4" onClick={onSubmitHandler}>{!currentElement ? `Add` : `Update Input`}</Button>
      </div>
    </Col>
  );
}

export default AddOrEditElementalLinkInput;
